import { API_AUTH, setTokenGlobal } from "../common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}

const DanhSachNhomQuyenApi = {
  list: ({ sSearch, trangthai }) =>
    API_AUTH.get(`UGroup/GetUGroup?sSearch=${sSearch}&trangthai=${trangthai}`, {}),
  xoaNhomQuyen: (id) => {
    return API_AUTH.post(`UGroup/DeleteUGroupById?id=${id}`, {});
  },
  khoaNhomQuyen: (id) => {
    return API_AUTH.post(`UGroup/LockOrUnLockUGroupById?id=${id}`, {});
  },
  addNhomQuyen: (params) =>
    API_AUTH.post("UGroup/InsertUOrUpdateUGroup", params),
  listMenu: () => {
    return API_AUTH.get(`Role/GetAllRoles`, {});
  },
  chiTietNhomQuyen: (ugroupId) => {
    return API_AUTH.get(`UGroup/GetUGroupDetails?ugroupId=${ugroupId}`, {});
  },
};

export default DanhSachNhomQuyenApi;
